'use client'

import { useSyncPhysicalGamepads } from '@/hooks/useSyncPhysicalGamepads'

export default function PhysicalGamepadsListener() {
  useSyncPhysicalGamepads()

  return null
}